import React from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
// import { removeHTML } from '../../utils'
// import { ProgressBar } from '../ProgressBar'
// import flecha_s from "../HeaderCourses/assets/flecha-s.png";
import logoSence from '../../assets/Logo_sence_blanco.png'

export const CourseCard = ({ item = null, moodle, lang, imgurl,categoryName }) => {
  /*   const enddate = new Date(item.startdate).toDateString() */
  /*   const options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }; */
  const theme = useTheme();
  const navigation = useNavigate();
  const backgroundref = React.useRef(null);

 /*  React.useEffect(() => {
    if (item.overviewfiles.length > 0) {
      let imgurl = moodle.getCourseImg(item);
      backgroundref.current.style.backgroundImage = `url(${imgurl})`;
    } */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  /* }, []); */

  const handleNavigation = (percentage) => {
    /* navigation(`/detailcourse/${percentage}/${item.id}`); */
    // localStorage.setItem("courseProgress", JSON.stringify(percentage));
    moodle.setCurrentModules(null);
    navigation(`/detailcourse/${item.id}`);
  };

  return (
    <>
     <div className="relative w-full max-w-[350px]">
      {/* Outer Glow Container - Similar al login */}
      <div
        style={{
          position: "absolute",
          top: "-10px",
          left: "-10px",
          right: "-10px",
          bottom: "-10px",
          backgroundColor: "#2e2e3933",
          /* borderRadius: "14px", */
          filter: "blur(20px)",
          opacity: "0.3",
          zIndex: 0,
        }}
      ></div>

      {/* Gradient Border Container */}
      <div
        className="relative z-10 my-5 rounded-[10px] border-[1px] overflow-hidden shadow-[0_4px_4px_rgba(0,0,0,0.25)] hover:shadow-[0_12px_40px_rgba(0,0,0,0.4)] transition-all duration-300 group"
        style={{
          /* padding: '10px', */
          borderColor: theme.mode === "dark" ? "#66666699" : "#e2e8f0",
          /* background: theme.mode === "dark" 
            ? 'linear-gradient(123deg, rgba(113, 113, 113, 0.67) 0%, rgb(4, 4, 4) 100%)'
            : 'linear-gradient(135deg, #e2e8f033 0%, #cbd5e133 100%)' */
        }}
      >
        {/* Card Content */}
        <div 
          className="relative flex flex-col h-full backdrop-blur-sm"
          style={{
            backgroundColor: theme.mode === "light" ? "rgb(249, 249, 249)" : "rgb(27, 28, 45)"//theme.colors.background_dark,
          }}
        >
          {/* Image Container */}
          <div className="relative aspect-video overflow-hidden">
            <div
              ref={backgroundref}
              style={{ backgroundImage: `url(${imgurl})` }}
              className="h-full w-full bg-cover bg-center transform group-hover:scale-110 group-hover:-translate-y-4 transition-transform duration-500"
            />
            
            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/30  via-black/5  to-transparent"></div>
            

            {/* Sence Logo */}
            {item && item.idnumber.includes("sence") &&<div className="relative">
        <img src={logoSence} alt="logo-sence" className="w-36 h-auto absolute right-0 bottom-0 drop-shadow-lg m-2 " /> 

        </div>}

            {/* Progress Badge */}
          </div>

          {/* Content Section */}
          <div className="flex flex-col flex-grow px-5 pb-4 pt-[1rem]">
            
            {/* Category Tag */}
            <div className="h-[26px] mb-3">
              {categoryName ? (
                <span 
                  className="inline-flex items-center px-3 py-1 text-xs font-outfit font-medium rounded-full transition-colors"
                  style={{
                    backgroundColor: "rgba(211, 196, 174, 0.12)",
                    borderColor: "rgba(211, 196, 174, 0.16)",
                    borderWidth: "0.5px",
                    borderStyle: "solid",
                    color: theme.mode === "light" ? "#5b5143" : "#d3c4ae",
                    fontSize: '12px'
                  }}
                >
                  {categoryName}
                </span>
              ) : (
                <div 
                  className="h-[24px] rounded-full w-24 animate-pulse"
                  style={{
                    backgroundColor: "rgba(211, 196, 174, 0.12)",
                    borderColor: "rgba(211, 196, 174, 0.16)",
                    borderWidth: '0.5px',
                    borderStyle: 'solid'
                  }}
                />
              )}
            </div>
            {/* Course Title */}
            <h2
              className="text-3xl font-outfit line-clamp-2 mb-2"
              style={{ 
                color: theme.mode === "dark" ? "rgb(240, 231, 218)" : theme.colors.background_dark,
                fontSize: '20px',
                fontWeight: '700',
                lineHeight: '1.3'
              }}
              title={item.fullname}
            >
              {item.fullname}
            </h2>

            {/* Progress Section */}
            <div className="mt-3 space-y-2">
              {/* Progress Label */}
              <div className="flex justify-between items-center ">
                <span 
                  className="text-base font-medium "
                  style={{ color: theme.mode === "light" ? "#64748b" : "rgb(229, 211, 185)" }}
                >
                  Progreso
                </span>
                <span 
                  className="text-base font-bold "
                  style={{ color: "rgb(229, 211, 185)"}}
                >
                  {item?.progress?.toFixed(0) || 0}% Completado
                </span>
              </div>

              {/* Progress Bar */}
              <div className="w-full h-2.5 bg-[#c5c3be] dark:bg-gray-700 rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-500 ease-out"
                  style={{
                    width: `${item?.progress?.toFixed(0) || 0}%`,
                    background: "rgb(154, 217, 232)"//`linear-gradient(90deg, ${theme.colors.primary_light} 0%, ${theme.colors.tertiary_light} 100%)`,
                  }}
                ></div>
              </div>

              {/* Action Button */}
              <div className="mt-auto flex justify-center">
                <button
                  onClick={handleNavigation}
                  type="button"
                  style={{ 
                    borderColor: theme.colors.backgroundColorCardBtn,
                    color: theme.mode === "dark" ? "rgb(229, 211, 185)"/* theme.colors.backgroundColorCardBtn */ : theme.colors.background_dark,
                    fontSize:'18px',
                    fontWeight:'500',
                    /* backgroundColor: 'transparent', */
                    border: `1px solid rgba(154, 217, 232,0.2)`
                  }}
                  className="mt-8 mb-6 py-2.5 px-8 w-full rounded-[10px] font-outfit font-semibold  !border-[#ECB236] hover:bg-[#ECB236] transition-all duration-300 transform hover:shadow-lg active:scale-95  "
                >
                  {lang["Home"].course_btn}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    </>
  );
};
